import { Component, Mixins, Prop } from 'vue-property-decorator';
import {loading} from '@/decorators';
import StartupInfoMixins from './startupInfoMixins';
import AddSubjectModal from '../components/addSubjectModal/index.vue';
import CertificationModal from '../components/certificationModal/index.vue';
import PollUpdateTipModal from '../components/pollUpdateTipModal/index.vue';
import util from '@/utils/util';

const addSubjectModalCom = util.mountVueComponent(AddSubjectModal);
const certificationModalCom = util.mountVueComponent(CertificationModal);
const pollUpdateTipModalCom = util.mountVueComponent(PollUpdateTipModal);

@Component
export default class FirmTableMixins extends Mixins(StartupInfoMixins) {
  @Prop({type: Object,default() {return {};},})
  protected data!: TypeCertification.CustomerStartupInfo;
  /** 列表数据加载状态 */
  protected loading = false;
  protected dataList!: TypeCertification.RegisterProcessSignBodyResp[];

  protected async submitAudit(params: TypeCertification.SubmitAuthParam):
    Promise<TypeCertification.SubmitAuthResult | null> {
    const res = await this.$api.certification.submitAuth<TypeCertification.SubmitAuthResult>(params);
    if (res.code === 0) {
      return res.data;
    } else {
      return null;
    }
  }
  /**
   * @description: 获取主体信息列表
   * @return {*}
   */
  @loading('loading')
  protected async queryCustomerFirmList() {
    const res = await this.$api.certification.queryCustomerFirmList();
    if (res.code === 0) {
      this.dataList = res.data;
    }
  }
  /**
   * @description: 更新主体列表信息
   * @param {number} status
   * @return {*}
   */  
  protected updateFirmList() {
    /** 待签约页面使用的是startupInfo接口生成的列表数据，其他流程（认证、待审核）使用新接口获取数据 */
    if (this.data.status === this.$enum.mine.CustomerStartupStatusEnum.SIGN_CONTRACT) {
      const data = this.queryStartupInfo();
      this.$emit('submit', data);
    } else {
      this.queryCustomerFirmList();
    }
  }
  /**
   * @description: 认证信息
   * @param {*} isPool 是否轮询监听状态
   * @return {*}
   */
  protected approveFirm(isPool: boolean, data: TypeCertification.CustomerFirmInfo) {
    /** 如果已经认证过会自动转为审核中状态，所以无需轮询检测主体的最新状态 */
    if (!isPool) {
      this.updateSubjectStatus((info) => {
        this.$emit('submit', {
          status: info.status,
        });
        this.updateFirmList();
      });
      return;
    }
    pollUpdateTipModalCom({
      parent: this,
      propsData: {
        isPool,
        data: data,
        onSuccess: () => {
          this.$emit('submit', {
            status: this.$enum.mine.CustomerStartupStatusEnum.AUDIT_PENDING,
          });
          this.updateFirmList();
        }
      }
    });
  }
  /**
   * @description: 编辑主体信息
   * @param {*} data 参数
   * @return {*}
   */
  protected async handleEdit(accountCode: string) {
    const info = await this.queryAccountCodeStartupInfo({
      account_code: accountCode,
    });
    addSubjectModalCom({
      parent: this,
      propsData: {
        title: this.t('编辑主体信息'),
        data: info,
        onSuccess: () => {
          this.updateFirmList();
        }
      },
    });
  }
  /**
   * @description: 走认证流程
   * @param {*} data 主体信息
   * @return {*}
   */
  protected async handleApprove(accountCode: string) {
    const info = await this.queryAccountCodeStartupInfo({
      account_code: accountCode,
    });
    certificationModalCom({
      parent: this,
      propsData: {
        data: info,
        onSuccess: (isPool: boolean) => {
          this.approveFirm(isPool, info);
        }
      }
    });
  }

  /**
   * @description: 提交审核
   * @param {*} data 数据参数
   * @return {*}
   */
  protected handleSubmit(accountCode: string) {
    const h = this.$createElement;
    this.$confirm({
      title: this.t('提交确认'),
      okText: this.t('提交审核'),
      content: (
        <div>
          <p class='m-0'>{this.t('主体信息提交审核后不可修改，请确保主体信息填写正确。')}</p>
          <p>{this.t('确认提交审核？')}</p>
        </div>
      ),
      onOk: async () => {
        await this.submitAudit({
          account_code: accountCode,
        });
        this.updateSubjectStatus((info) => {
          this.$emit('submit', {
            status: info.status,
          });
          this.updateFirmList();
        });
      },
    });
  }
  /**
   * @description: 添加主体信息
   * @return {*}
   */
  protected handleAddFirm() {
    addSubjectModalCom({
      parent: this,
      propsData: {
        title: this.t('添加主体信息'),
        data: {},
        onSuccess: () => {
          this.updateFirmList();
        }
      },
    });
  }
  /**
   * @description: 复制主体
   * @return {*}
   */
  protected async handleCopy(accountCode: string) {
    const info = await this.queryAccountCodeStartupInfo({
      account_code: accountCode,
    });
    delete info.sign_body_info.account_code;
    addSubjectModalCom({
      parent: this,
      propsData: {
        title: this.t('复制主体信息'),
        data: info,
        onSuccess: () => {
          this.updateFirmList();
        }
      },
    });
  }
}